import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Render error:', error, info.componentStack);
    this.props.onError?.(error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.reset);
      }
      return (
        <div role="alert" style={{ padding: 24, textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <pre style={{ color: '#c00', fontSize: 13, margin: '12px 0' }}>
            {this.state.error?.message}
          </pre>
          <button onClick={this.reset} className="pico-btn">Try again</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
